export const defaultLanguage = 'en';

export const supportedLanguages = [
	{code: 'en', name: 'English'},
	{code: 'zh', name: '中文'},
	{code: 'ja', name: '日本語'},
];
